import { useEffect } from "react"
import { loadScript } from "../utils/loadScripts"
import { Link } from "react-router-dom";
import Footer from "./Footer"
import Header from "./Header"

export default function Careers() {

    useEffect(() => {
        const init = async () => {
            await loadScript("/assets/js/plugins/jquery.min.js")
            await loadScript("/assets/js/plugins/swup.min.js")
            await loadScript("/assets/js/plugins/swiper.min.js")
            await loadScript("/assets/js/plugins/fancybox.min.js")
            await loadScript("/assets/js/plugins/gsap.min.js")
            await loadScript("/assets/js/plugins/smooth-scroll.js")
            await loadScript("/assets/js/plugins/ScrollTrigger.min.js")
            await loadScript("/assets/js/plugins/ScrollTo.min.js")

            await loadScript("assets/js/main.js")
        }

        init()

    }, [])
    return (
        <>

            <div id="swup">

                <Header />

                {/* <!-- content --> */}
                <div className="mil-content">
                    <div id="swupMain" className="mil-main-transition">

                        {/* <!-- banner --> */}
                        <div className="mil-inner-banner mil-p-0-120">
                            <div className="mil-banner-content mil-up">
                                <div className="mil-animation-frame">
                                    <div className="mil-animation mil-position-4 mil-dark mil-scale" data-value-1="6" data-value-2="1.4"></div>
                                </div>
                                <div className="container">
                                    <ul className="mil-breadcrumbs mil-mb-60">
                                        <li><a href="/">Homepage</a></li>
                                        <li><a href="#.">Careers</a></li>
                                    </ul>
                                    <h1 className="mil-mb-60">Careers</h1>
                                    <a href="/careers" className="mil-link mil-dark mil-arrow-place mil-down-arrow">
                                        <span>Positions open</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* <!-- banner end -->

                <!-- Job Listing --> */}
                        <section id="career">
                            <div className="container .mil-p-60-120">
                                <div className="row">
                                    <div className="col-lg-12">

                                        <Link to="/career-details-1" className="mil-blog-card mil-blog-card-hori mil-more mil-mb-60">
                                            <div className="mil-post-descr">
                                                <h4 className="mil-up mil-mb-30">Digital Marketing Executive Intern</h4>
                                                <p className="mil-post-text mil-up mil-mb-30">Support digital marketing campaigns, social media management, content creation,
                                                 SEO activities, and performance tracking while gaining hands-on industry experience.</p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </Link>

                                    </div>
                                    <div className="col-lg-12">

                                       <Link to="/career-details-2" className="mil-blog-card mil-blog-card-hori mil-more mil-mb-60">
                                            <div className="mil-post-descr">
                                                <h4 className="mil-up mil-mb-30">Full Stack Developer Intern</h4>
                                                <p className="mil-post-text mil-up mil-mb-30">Work on real-world web applications using front-end and back-end technologies,
                                                  APIs, databases, and modern development frameworks in a collaborative environment.</p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-12">
                                       <Link to="/career-details-3" className="mil-blog-card mil-blog-card-hori mil-more mil-mb-60">
                                            <div className="mil-post-descr">
                                                <h4 className="mil-up mil-mb-30">Business Development Executive Intern</h4>
                                                <p className="mil-post-text mil-up mil-mb-30">
                                                 Assist in lead generation, client outreach, market research, proposal preparation,
                                                 and business growth initiatives while developing professional communication skills.
                                                </p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </Link>

                                    </div>
                                    <div className="col-lg-12">

                                        <Link to="/career-details-4" className="mil-blog-card mil-blog-card-hori mil-more mil-mb-60">
                                            <div className="mil-post-descr">
                                                <h4 className="mil-up mil-mb-30">Graphic Design Intern</h4>
                                                <p className="mil-post-text mil-up mil-mb-30">
                                                 Create engaging visual content, social media creatives, marketing materials,
                                                 and branding assets while learning industry-standard design practices.
                                                </p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </Link>

                                    </div>
                                    <div className="col-lg-12">

                                        <Link to="/career-details-5" className="mil-blog-card mil-blog-card-hori mil-more mil-mb-60">
                                            <div className="mil-post-descr">
                                                <h4 className="mil-up mil-mb-30">Senior Motion Graphic Designer</h4>
                                                <p className="mil-post-text mil-up mil-mb-30">
                                                 Design and develop high-quality motion graphics, animations, video content,
                                                and visual storytelling assets for digital campaigns and brand communication.
                                                </p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </Link>

                                    </div>
                                    <div className="col-lg-12">

                                        <Link to="/career-details-6" className="mil-blog-card mil-blog-card-hori mil-more mil-mb-60">
                                            <div className="mil-post-descr">
                                                <h4 className="mil-up mil-mb-30">Senior Copywriter</h4>
                                                <p className="mil-post-text mil-up mil-mb-30">
                                                Develop compelling copy for advertisements, websites, social media, campaigns,
                                                and brand communications that engage audiences and drive results.
                                                </p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </Link>

                                    </div>
                                     <div className="col-lg-12">

                                        <Link to="/career-details-7" className="mil-blog-card mil-blog-card-hori mil-more mil-mb-60">
                                            <div className="mil-post-descr">
                                                <h4 className="mil-up mil-mb-30">Creative Strategist</h4>
                                                <p className="mil-post-text mil-up mil-mb-30">
                                                Lead creative planning, campaign ideation, brand positioning, and strategic
                                                content initiatives to deliver impactful marketing solutions.
                                                </p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- Job Listing end -->

                <!-- call to action --> */}
                        <section className="mil-soft-bg">
                            <div className="container mil-p-120-120">
                                <div className="row">
                                    <div className="col-lg-10">

                                        <span className="mil-suptitle mil-suptitle-right mil-suptitle-dark mil-up">Looking to make your mark? We'll help you turn <br /> your project into a success story.</span>

                                    </div>
                                </div>
                                <div className="mil-center">
                                    <h2 className="mil-up mil-mb-60">Stay up-to-date <span className="mil-thin">with the</span><br /> latest news by <span className="mil-thin">subscribing</span><br /> to our <span className="mil-thin">newsletter!</span></h2>
                                    <div className="row justify-content-center mil-up">
                                        <div className="col-lg-4">
                                            <form className="mil-subscribe-form mil-subscribe-form-2 mil-up">
                                                <input type="text" placeholder="Enter our email" />
                                                <button type="submit" className="mil-button mil-icon-button-sm mil-arrow-place"></button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
                {/* <!-- content --> */}
                <Footer />

            </div>

        </>
    )
}